import Component from 'navigation/component/Component'

class SwitchButton extends Component {
  constructor (el, blocs) {
    super(...arguments)
    this.el = el
    this.buildSpan()
  }

  buildSpan () {
    this.el.setAttribute('data-hover', this.el.textContent)
    this.span = document.createElement('span')
    this.span.innerHTML = this.el.innerHTML
    this.span.classList.add('switch-button__inner')
    this.el.innerHTML = ''
    this.el.appendChild(this.span)
  }
}

export default SwitchButton
